import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import { EPlayerIconType, PlayerIcon } from './Icons';
import * as styles from './VideoPreview.css';

export interface IVideoPreviewProps {
  url: string;
  iconType: EPlayerIconType;
  fit?: 'contain';
  loading?: React.ImgHTMLAttributes<HTMLImageElement>['loading'];
  onClick?(event: React.MouseEvent<HTMLDivElement>): void;
}

export function VideoPreview({ url, iconType, fit, loading, onClick }: IVideoPreviewProps) {
  return (
    <div
      {...mergeStyles(styles['container'], fit === 'contain' && styles['container--contain'])}
      onClick={onClick}
      data-testid="VideoPreview"
    >
      <img className={styles['image']} src={url} alt="" loading={loading} />
      <PlayerIcon type={iconType} />
    </div>
  );
}
